import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const postDictionary = (params) => {
    return axios.post(`${backendHost}/api/admin/dictionary`, params);
};